/**
 * FormContainer Component
 *
 * Layout wrapper for form steps. Provides consistent spacing and structure.
 */

import React from "react";
import classNames from "classnames";
import styles from "./FormContainer.module.css";

export interface FormContainerProps {
  /** Child elements */
  children: React.ReactNode;
  /** Optional CSS class */
  className?: string;
  /** Test ID for outer wrapper */
  "data-testid"?: string;
  /** Test ID for inner content area */
  contentTestId?: string;
}

export const FormContainer: React.FC<FormContainerProps> = ({
  children,
  className,
  "data-testid": testId,
  contentTestId,
}) => {
  return (
    <div
      className={classNames(styles.formContainer, className)}
      data-testid={testId}
    >
      <div className={styles.content} data-testid={contentTestId}>
        {children}
      </div>
    </div>
  );
};

FormContainer.displayName = "FormContainer";

export default FormContainer;
